import React, { useState, useEffect, useContext  } from 'react'
import axios from 'axios';
import Swal from 'sweetalert2';

import { AppContext } from "../../../services/AppContext";
import AuthContext from '../../../context/auth-context';

import { MdEdit, MdErrorOutline, MdClose, MdAdd } from 'react-icons/md';
import classes from './EstudiosSuperioresList.module.css';

import useGetInstitucion from '../../../hooks/useGetInstitucion';
import useGetTipoTitulo from '../../../hooks/useGetTipoTitulo';

import EstudiosSuperioresForm from './EstudiosSuperioresForm';
import Card from '../../UI/Card';


const EstudiosSuperiores = (props) => {
    const { setAppValues } = useContext(AppContext);
    const authContext = useContext(AuthContext);

    const [error, setError] = useState(false);

    const [requestListaEstudios, setRequestListaEstudios] = useState({ LOADING: true });
    const [listaEstudios, setListaEstudios] = useState([]);

    useEffect(() => {
        if(requestListaEstudios.LOADING){
            Swal.fire({
                title: `Loading...
                    <div class="spinner-border text-primary mt-4" role="status" />
                `,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            return;
        }
        Swal.close();

        if(requestListaEstudios.STATUS && requestListaEstudios.STATUS === "SUCCESS"){
            setError(false);
            var arrListaEstudios = [];
            for( let key in requestListaEstudios ){
                if( requestListaEstudios.hasOwnProperty(key) && key !== "STATUS" ){
                    arrListaEstudios.push(requestListaEstudios[key]);
                }
            }
            setListaEstudios([...arrListaEstudios]);

        } else if(requestListaEstudios.STATUS && requestListaEstudios.STATUS === "ERROR"){
            setError(true);

            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: requestListaEstudios.ERROR.MESSAGE,
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });

        } else {
            setError(true);
            
            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: 'Ocurrió un problema, intentelo más tarde',
                showConfirmButton: false,
            });
        }

    }, [requestListaEstudios,setListaEstudios]);

    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({});
    const [isUpdate, setIsUpdate] = useState(false);

    const instituciones = useGetInstitucion();
    const grados = useGetTipoTitulo();

    const handleShowForm = () => {
        setFormData({});
        setShowForm(true);
        setIsUpdate(false);
    }

    const editEstudioHanlder = (idEstudio) => {
        setFormData(listaEstudios.find( estudio => estudio.id === idEstudio ));
        setShowForm(true);
        setIsUpdate(true);
    }
    
    const deleteEstudioHanlder = (idToDelete) => {
        // Aqui deberia hacerse un DELETE request y que la API nos devuelva la lista actualizada ya sin la fila que se acaba de borrar.
        // Por el momento solo se borra de la lista para simular dicho proceso.

        const form_data = new FormData();
        form_data.append('id', idToDelete);
        form_data.append('deleteEstudiosSuperiores', 1);
        form_data.append('idToken', authContext.token);

        axios.post(process.env.REACT_APP_API_URL, form_data)
            .then(res => {
                Swal.fire({
                    icon: 'success',
                    title: 'Datos guardados!',
                    showConfirmButton: false,
                    timer: 2500
                });
            })
            .catch((error) => {
                console.log(error)
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un problema, intentelo más tarde',
                    showConfirmButton: false,
                    timer: 3500
                });
            }); 
        
        if((listaEstudios.length - 1) === 0){
            setAppValues(
                prev => {
                    let perfil = !prev.estudiosSuperiores ? prev.perfil : prev.perfil-20;
                    return { ...prev, estudiosSuperiores: false, perfil };
                }
            );
        }
    }

    const onCompletado = (form) => {
        props.onCompletado(form);
    }

    useEffect(() => {
        const data = async () => {
            const form_data = new FormData();
            form_data.append('idToken', authContext.token);
            const response = await axios.post(process.env.REACT_APP_API_URL+'?getEstudiosSuperiores=true', form_data);
            
            if(response.data.STATUS && response.data.STATUS === "SUCCESS"){
                setRequestListaEstudios(response.data);

            } else if(response.data.STATUS && response.data.STATUS === "ERROR"){
                setRequestListaEstudios(response.data);

            } else {
                setRequestListaEstudios(
                    {
                        STATUS : "ERROR",
                        ERROR: {
                            ID : "error-get-contacto",
                            MESSAGE : "No se pudo obtener la información de contacto."
                        }
                    }
                );

            }
        }

        data()
            .catch(console.error);
    }, [authContext.token, setRequestListaEstudios,listaEstudios]); 

    return (
        <>
        {
            error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body d-flex align-items-center justify-content-center" style={{ height: '565px' }}>
                            <div className="text-center" style={{ color: 'rgba(0,0,0,.3)', fontSize: '2.5rem' }} >
                                <span style={{ fontSize: "7rem" }}><MdErrorOutline/></span>
                                <br />
                                ¡Error!
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        }
        {
            !error &&
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body">

                            {!showForm &&
                            <div className="row my-4">
                                <div className="col-md-10 offset-md-1">
                                    <table className="table table-striped table-hover" style={{userSelect: 'none'}}>
                                        <thead className="thead">
                                            <tr>
                                                <th scope="col" className="fs-5 fw-light">Grado</th>
                                                <th scope="col" className="fs-5 fw-light">Institución Educativa</th>
                                                <th scope="col" className="fs-5 fw-light">&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {   listaEstudios &&
                                                listaEstudios.length > 0 ?
                                                listaEstudios.map(
                                                    (estudio, index) => {
                                                        return (
                                                            <React.Fragment>

                                                            <tr key={estudio.id}>
                                                                <td className="text-black-50 fst-italic">
                                                                    { 
                                                                        grados.length > 0 ? 
                                                                        grados.find( grado => parseInt(grado.tipo_titulo) === estudio.grado ).nombre : 
                                                                        ""
                                                                    }
                                                                </td>
                                                                <td className="text-black-50 fst-italic">
                                                                    {
                                                                        (estudio.institucion === 8) ? 
                                                                            estudio.otraInstitucion
                                                                            :
                                                                            instituciones.length > 0 ? 
                                                                                instituciones.find( institucion => parseInt(institucion.institucion) === estudio.institucion ).descripcion
                                                                                :
                                                                                ""
                                                                    }
                                                                </td>
                                                                <td style={{whiteSpace: 'nowrap'}}>
                                                                    <span onClick={() => editEstudioHanlder(estudio.id)} className={`badge rounded-pill text-bg-light text-muted align-middle ${classes.listItemOption}`}>
                                                                        <MdEdit size={19} />
                                                                    </span>
                                                                    &nbsp;
                                                                    <span onClick={() => deleteEstudioHanlder(estudio.id)} className={`badge rounded-pill text-bg-light text-danger align-middle ${classes.listItemOption}`}>
                                                                        <MdClose size={19} />
                                                                    </span>
                                                                </td>
                                                            </tr>

                                            
                                                            </React.Fragment>


                                                        );
                                                    }
                                                )

                                                
                                                :
                                                <tr>
                                                    <td colSpan={3} className="text-black-50 fst-italic text-center">
                                                        No ha agregado ninguna institución
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>



                                <div className="col-md-10 offset-md-1 text-black-50" style={{userSelect: "left"}}>

                                                        * Si desea modificar algún dato o documento puede hacerlo dando clic en el ícono &nbsp;
                                                                        <MdEdit size={19} /> .
                                                        
                                                        
                                                   

                                </div>

                                <div className="col-md-10 offset-md-1" style={{textAlign: "right"}}>
                                    <button className="btn btn-danger" type="button" onClick={handleShowForm}><MdAdd/> Agregar</button>
                                </div>
                            </div>
                            }

                            {showForm &&
                                <EstudiosSuperioresForm
                                    token={authContext.token}
                                    setShowForm={setShowForm}
                                    formData={formData}
                                    instituciones={instituciones}
                                    grados={grados} 
                                    isUpdate={isUpdate}
                                    onCompletado={onCompletado}
                                />
                            }
                        </div>
                    </Card>
                </div>
            </div>
        }
        </>
    )
}

export default EstudiosSuperiores